import React from "react";
import NeustartArticle, { meta as neustartMeta } from "../articles/neustart";
import EuropastartenArticle, {
  meta as EuropastartenMeta,
} from "../articles/europastarten";
import FuehlenstartenArticle, {
  meta as FuehlenstartenMeta,
} from "../articles/fuehlenstarten";
import KreativitaetstartenArticle, {
  meta as KreativitaetstartenMeta,
} from "../articles/kreativitaetstarten";
import KopfstandstartenArticle, {
  meta as KopfstandstartenMeta,
} from "../articles/kopfstandstarten";
import UpdatestartenArticle, {
  meta as UpdatestartenMeta,
} from "../articles/updatestarten";
import WachstumstartenArticle, {
  meta as WachstumstartenMeta,
} from "../articles/wachstumstarten";
import MotorstartenArticle, {
  meta as MotorstartenMeta,
} from "../articles/motorstarten";
import HamsternstoppenArticle, {
  meta as HamsternstoppenMeta,
} from "../articles/hamsternstoppen";
import StillestoppenArticle, {
  meta as StillestoppenMeta,
} from "../articles/stillestoppen";
import WachstumstoppenArticle, {
  meta as WachstumstoppenMeta,
} from "../articles/wachstumstoppen";
import SpaltungstoppenArticle, {
  meta as SpaltungstoppenMeta,
} from "../articles/spaltungstoppen";
import MotorstoppenArticle, {
  meta as MotorstoppenMeta,
} from "../articles/motorstoppen";
import KlimakrisestoppenArticle, {
  meta as KlimakrisestoppenMeta,
} from "../articles/klimakrisestoppen";
import SmombiesstoppenArticle, {
  meta as SmombiesstoppenMeta,
} from "../articles/smombiesstoppen";
import WeiterstreitenArticle, {
  meta as WeiterstreitenMeta,
} from "../articles/weiterstreiten";
import WeiterzoomenArticle, {
  meta as WeiterzoomenMeta,
} from "../articles/weiterzoomen";
import WeitertestenArticle, {
  meta as WeitertestenMeta,
} from "../articles/weitertesten";
import WeiterlernenArticle, {
  meta as WeiterlernenMeta,
} from "../articles/weiterlernen";
import WeiterdenkenArticle, {
  meta as WeiterdenkenMeta,
} from "../articles/weiterdenken";
import WeiterhelfenArticle, {
  meta as WeiterhelfenMeta,
} from "../articles/weiterhelfen";
// import WeiterhaltungzeigenArticle, { meta as WeiterhaltungzeigenMeta } from "../articles/weiterhaltungzeigen"

const allArticles = [
  {
    meta: neustartMeta,
    component: NeustartArticle,
  },
  {
    meta: EuropastartenMeta,
    component: EuropastartenArticle,
  },
  {
    meta: FuehlenstartenMeta,
    component: FuehlenstartenArticle,
  },
  {
    meta: KreativitaetstartenMeta,
    component: KreativitaetstartenArticle,
  },
  {
    meta: KopfstandstartenMeta,
    component: KopfstandstartenArticle,
  },
  {
    meta: UpdatestartenMeta,
    component: UpdatestartenArticle,
  },
  {
    meta: WachstumstartenMeta,
    component: WachstumstartenArticle,
  },
  {
    meta: MotorstartenMeta,
    component: MotorstartenArticle,
  },
  {
    meta: HamsternstoppenMeta,
    component: HamsternstoppenArticle,
  },
  {
    meta: StillestoppenMeta,
    component: StillestoppenArticle,
  },
  {
    meta: WachstumstoppenMeta,
    component: WachstumstoppenArticle,
  },
  {
    meta: SpaltungstoppenMeta,
    component: SpaltungstoppenArticle,
  },
  {
    meta: MotorstoppenMeta,
    component: MotorstoppenArticle,
  },
  {
    meta: KlimakrisestoppenMeta,
    component: KlimakrisestoppenArticle,
  },
  {
    meta: SmombiesstoppenMeta,
    component: SmombiesstoppenArticle,
  },
  {
    meta: WeiterstreitenMeta,
    component: WeiterstreitenArticle,
  },
  {
    meta: WeiterzoomenMeta,
    component: WeiterzoomenArticle,
  },
  {
    meta: WeitertestenMeta,
    component: WeitertestenArticle,
  },
  {
    meta: WeiterlernenMeta,
    component: WeiterlernenArticle,
  },
  {
    meta: WeiterdenkenMeta,
    component: WeiterdenkenArticle,
  },
  {
    meta: WeiterhelfenMeta,
    component: WeiterhelfenArticle,
  },
];
export default allArticles;

export const employees = [
  {
    firstName: "Anna",
    lastName: "Kapathanasiou",
    tag: "#durchstarten",
    src: "../assets/employees/Anna-Kapathanasiou.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Dr. Michael",
    lastName: "Wenzler",
    tag: "#fairebildung",
    src: "../assets/employees/Michael-Wenzler.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Lena",
    lastName: "Gerstlauer",
    tag: "#ärmelhoch",
    src: "../assets/employees/Lena-Buck.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Nadia",
    lastName: "Lindemann",
    tag: "#dontstopbelieving",
    src: "../assets/employees/Nadia-Heide.jpg",
    iconSrc: "stop",
  },
  {
    firstName: "Cosima-Maria",
    lastName: "Weyers",
    tag: "#abenteuer",
    src: "../assets/employees/Cosima-Maria Weyers.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Jan Philipp",
    lastName: "Schewe",
    tag: "#blacklivesmatter",
    src: "../assets/employees/Jan-Philipp_Schewe.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Tania",
    lastName: "Teschner",
    tag: "#weiterpläneschmieden",
    src: "../assets/employees/Tania-Teschner.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Franziska",
    lastName: "Klaeger",
    tag: "#reusereducerecycle",
    src: "../assets/employees/Franziska-Klaeger.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Dr. Stefan",
    lastName: "Hoffmann",
    tag: "#solidarität",
    src: "../assets/employees/Stefan-Hoffmann.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Sven",
    lastName: "Walter",
    tag: "#heiterweiter",
    src: "../assets/employees/Sven-Walter.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Dr. Angela",
    lastName: "Kalous",
    tag: "#pandemiestoppen",
    src: "../assets/employees/Angela-Kalous.jpg",
    iconSrc: "stop",
  },
  {
    firstName: "Dr. Ágnes",
    lastName: "Sebestyén",
    tag: "#reimagineglobalexchange",
    src: "../assets/employees/Agnes-Sebestyen.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Renate",
    lastName: "Feucht",
    tag: "#verschwörungstheorien",
    src: "../assets/employees/Renate_Feucht.jpg",
    iconSrc: "stop",
  },
  {
    firstName: "Kaya",
    lastName: "Uhlmann",
    tag: "#internationalvernetzen",
    src: "../assets/employees/Kaya-Uhlmann.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Dorena",
    lastName: "Kronhofmann",
    tag: "#zusammenkommen",
    src: "../assets/employees/Dorena-Kronhofmann.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Birgit",
    lastName: "Pfitzenmaier",
    tag: "#wahrheitundklarheit",
    src: "../assets/employees/Birgit-Pfitzenmaier.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Verena",
    lastName: "Kiefer",
    tag: "#startdoing",
    src: "../assets/employees/Verena-Kiefer.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Violeta",
    lastName: "Llugaxhija",
    tag: "#übergrenzenwachsen",
    src: "../assets/employees/Violeta-Llugaxhija.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Sabine",
    lastName: "Fischer",
    tag: "#weitergehts",
    src: "../assets/employees/Sabine-Fischer.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Nadja",
    lastName: "Zink",
    tag: "#gemeinschaft",
    src: "../assets/employees/Nadja-Zink.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Dr. Volker",
    lastName: "Scheil",
    tag: "#weiterruhebewahren",
    src: "../assets/employees/Volker-Scheil.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Christoph",
    lastName: "Dahl",
    tag: "#neustarten",
    src: "../assets/employees/Christoph-Dahl.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Irene",
    lastName: "Purschke",
    tag: "#veränderung",
    src: "../assets/employees/Irene-Purschke.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Markus",
    lastName: "Mütsch",
    tag: "#klimagerechtigkeit",
    src: "../assets/employees/Markus-Muetsch.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Dr. Philipp",
    lastName: "Jeandrée",
    tag: "#zuversichtlichbleiben",
    src: "../assets/employees/Philipp-Jeandree.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Stephan",
    lastName: "Etzel",
    tag: "#lockdown",
    src: "../assets/employees/Stephan-Etzel.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Ute",
    lastName: "Krüger",
    tag: "#bornequal",
    src: "../assets/employees/Ute-Krueger.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Thi Ai Linh",
    lastName: "Truong",
    tag: "#gerechtigkeit",
    src: "../assets/employees/Ai-Linh-Truong.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Zerrin",
    lastName: "Uysal",
    tag: "#vielfalt",
    src: "../assets/employees/Zerrin-Uysal.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Julia",
    lastName: "Kovar-Mühlhausen",
    tag: "#zeitfürmich",
    src: "../assets/employees/Julia-Kovar.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Dr. Lisa",
    lastName: "Rauer",
    tag: "#weiterforschen",
    src: "../assets/employees/Lisa-Rauer.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Dr. Andreas",
    lastName: "Weber",
    tag: "#bildungsungleichheitstoppen",
    src: "../assets/employees/Andreas-Weber.jpg",
    iconSrc: "stop",
  },
  {
    firstName: "Annegret",
    lastName: "Trettin",
    tag: "#studierenimausland",
    src: "../assets/employees/Annegret-Trettin.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Hans-Dieter",
    lastName: "Schader",
    tag: "#newfuture",
    src: "../assets/employees/Hans-Dieter-Schader.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Dagmar",
    lastName: "Kaiser",
    tag: "#sport",
    src: "../assets/employees/Dagmar-Kaiser.jpg",
    iconSrc: "start",
  },
  {
    firstName: "Heike",
    lastName: "Mangold-Ruck",
    tag: "#weiterimmerweiter",
    src: "../assets/employees/Heike-Mangold-Ruck.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Peter",
    lastName: "Kimmel",
    tag: "#weitermachen",
    src: "../assets/employees/Peter-Kimmel.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Gabriel",
    lastName: "Vocasek",
    tag: "#positivbleiben",
    src: "../assets/employees/Gabriel-Vocasek.jpg",
    iconSrc: "weiter",
  },
  {
    firstName: "Karin",
    lastName: "Priebe",
    tag: "#durchatmen",
    src: "../assets/employees/Karin-Priebe.jpg",
    iconSrc: "start",
  },
];
